import {
  apiGet, apiPost, apiDelete, apiUploadPost, apiDownloadPhoto,
} from '../../api/index';
import { urlUsers } from '../../api/urls';

export const CREATE_NEW_USER = 'CREATE_NEW_USER';
export const SET_USER_VALUE = 'SET_USER_VALUE';
export const FETCH_USER = 'FETCH_USER';
export const FETCH_USER_LOADING = 'FETCH_USER_LOADING';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_FAILED = 'FETCH_USER_FAILED';

export const POST_USER_LOADING = 'POST_USER_LOADING';
export const POST_USER_SUCCESS = 'POST_USER_SUCCESS';
export const POST_USER_FAILED = 'POST_USER_FAILED';

export const setUserValue = values => ({ type: SET_USER_VALUE, payload: values });
export const fetchUserLoading = () => ({ type: FETCH_USER_LOADING });
export const fetchUserSuccess = user => ({ type: FETCH_USER_SUCCESS, payload: user });
export const fetchUserFailed = error => ({ type: FETCH_USER_FAILED, payload: error });
// export const createNewUser = () => ({ type: CREATE_NEW_USER });

export const postUserLoading = () => ({ type: POST_USER_LOADING });
export const postUserSuccess = user => ({ type: POST_USER_SUCCESS, payload: user });
export const postUserFailed = error => ({ type: POST_USER_FAILED, payload: error });

export function fetchUser(id, callback) {
  return apiGet(`${urlUsers}/${id}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}

export function saveUser(user, callback) {
  return apiPost(`${urlUsers}`, user)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}

export function setEditUserProfile({ id, onSuccess, onError }) {
  return apiPost(`${urlUsers}/${id}/edit-profile`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (onSuccess) onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function savePhoto({
  id, files, onSuccess, onError,
}) {
  return apiUploadPost(`${urlUsers}/${id}/photo`, files)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }

      if (onSuccess) onSuccess(res);

      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function fetchPhoto({ id, onSuccess, onError }) {
  return apiDownloadPhoto(`${urlUsers}/${id}/photo`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }

      if (onSuccess) onSuccess(res);

      return res;
    })
    .catch((error) => {
      if (onError) onError(error);
    });
}

export function deleteUser(id, callback) {
  return apiDelete(`${urlUsers}/${id}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}

export function resetUserPassword(email, callback) {
  return apiGet(`${urlUsers}/reset_password/${email}`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (callback && callback.onSuccess) callback.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (callback && callback.onError) callback.onError(error);
    });
}

export function fetchFormDatas(params) {
  return apiGet(`${urlUsers}/form_data`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (params && params.onSuccess) params.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (params && params.onError) params.onError(error);
    });
}
